import React, { Component } from 'react';
import CreditActions from './CreditActions.jsx';
import { connect } from 'react-redux';
import { navigate } from '../modules/high_level_actions';
import { upgradePositiveMemberSoft } from '../modules/membership_actions';
import { openUpgradeFlowModal, openCreditBoxModal } from '../modules/active_modal';

class CreditsBox extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let {dispatch}            = this.props;
    let oCreditsDisplay       = '';
    let sMessage              = '';
    let iCreditTotal          = '';
    let fCreditPrice          = 0.00;
    let iCreditQuantity       = '';
    let iDaysUntilNewCredits  = '';
    let bAreCreditsAvailable  = true;
    let sResponded            = '';
    let iDaysLeftToRespond    = '';
    let oHeaderText           = <h4 className="alt highlight-color">Want to save money every month?</h4>;

    const oMemberCreditHelp = (
      <div>
        <h5>What are member credits?</h5>
          <p>
            Member Credits allow you to purchase any book on the site for
            just ${fCreditPrice}. On the 1st day of each month, members have the option of
            purchasing {iCreditQuantity} Member Credits for ${fCreditPrice} each. Go shopping and use your Member Credits
            right away, or save them up to use later at your convenience.
          </p>
      </div>
      );
    if ( this.props.customer && this.props.customer.current_cycle ) {
      iCreditTotal          = this.props.customer.credit_total;
      fCreditPrice          = this.props.customer.current_cycle.credit_price;
      iCreditQuantity       = this.props.customer.current_cycle.credit_quantity;
      bAreCreditsAvailable  = this.props.customer.current_cycle.active;
      iDaysUntilNewCredits  = this.props.customer.current_cycle.days_until_next_cycle;
      sResponded            = this.props.customer.current_cycle.response;
      iDaysLeftToRespond    = this.props.customer.current_cycle.days_left_to_respond;

      // check if the member is posilite - show upgrade message if so
      if(this.props.customer.fulfillment_type !== "Negative"){
        let oUpgradeMembershipLink = (<a className="button btn-primary fat full-width" onClick={() => dispatch( openUpgradeFlowModal() )}>Learn More</a>);
        if ( this.props.customer.fulfillment_type === 'Positive' )
          oUpgradeMembershipLink = (<a className="button btn-primary fat full-width" onClick={() => dispatch( upgradePositiveMemberSoft() )}>Learn More</a>);
        oCreditsDisplay = (
          <div>
            <p>
              Upgrade your membership when you make a purchase.
            </p>
            {oUpgradeMembershipLink}
            <div className="help-link" onClick={() => dispatch( openCreditBoxModal() )}>cancel</div>
          </div>
        );
      } else {
        // assume credits are not available
        let sResponseMessage = '';
        oHeaderText = <h4 className="alt highlight-color credits-exist">Your Available Credits: {iCreditTotal}</h4>;
        if (sResponded === 'active_accept' || sResponded === 'passive_accept') {
          sResponseMessage = 'You have purchased this month\'s credits';
        } else if (sResponded === 'active_decline' || sResponded === 'passive_decline') {
          sResponseMessage = 'You have skipped this month\'s credits.';
        }

        oCreditsDisplay = (
          <div>
            <p>{sResponseMessage}</p>
            <a className="button btn-primary fat full-width" onClick={() => dispatch( openCreditBoxModal() )}>Close</a>
          </div>
        );
        // if credits are available and member has not responded
        if (bAreCreditsAvailable && !sResponded && !['CRS','SFC'].includes(this.props.tla)) {
          oCreditsDisplay = (
             <CreditActions />
          );
        }
      }
    }

    return (
        <div className="credits-box" >
        <div className="marker-arrow"></div>
          {oHeaderText}
          {oCreditsDisplay}
        </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'one_credit': state.store.one_credit,
      'customer': state.customer,
      'upgradeStatus': state.upgradeStatus,
      'paymentMethods': state.paymentMethods,
      'computedCart': state.computedCart
    };
}

export default connect(mapStateToProps)(CreditsBox);


// WEBPACK FOOTER //
// ./src/components/CreditsBox.jsx